<div class="event-badge" *ngIf="label">
    <zui-lozenge type="{{severity | severityToType}}" text="{{label | truncate:35}}"></zui-lozenge>
</div>
